/**
 * Joins a location path into `Root / Child / Leaf`.
 * `||`: an empty path joins to '', which falls back to `fallback` (usually the location name).
 */
export const formatLocationPath = (
	locationPath: Array<{ name?: string }> | null | undefined,
	fallback?: string
): string | undefined => locationPath?.map((node) => node.name).join(' / ') || fallback;
